export default __webpack_public_path__ + "static/media/paypal.c38c9322.svg";